import { render, staticRenderFns } from "./misProductosMasSolicitados.vue?vue&type=template&id=5f2584ec&"
import script from "./misProductosMasSolicitados.vue?vue&type=script&lang=js&"
export * from "./misProductosMasSolicitados.vue?vue&type=script&lang=js&"
import style0 from "./misProductosMasSolicitados.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports